import type { EventStatus } from '@/types';

export const statusText = (status: EventStatus): string => {
  if (status === 'live') return '进行中';
  if (status === 'upcoming') return '未开始';
  return '已结束';
};

export const statusClass = (status: EventStatus): string => {
  if (status === 'live') return 'bg-accent-500 text-background-50';
  if (status === 'upcoming') return 'bg-primary-100 text-primary-700 border border-primary-200';
  return 'bg-background-200 text-foreground-600 border border-background-300/60';
};

export const trendIcon = (trend: 'up' | 'down' | 'flat'): string => {
  if (trend === 'up') return 'ri-arrow-up-line';
  if (trend === 'down') return 'ri-arrow-down-line';
  return 'ri-subtract-line';
};

export const trendClass = (trend: 'up' | 'down' | 'flat'): string => {
  if (trend === 'up') return 'text-accent-600';
  if (trend === 'down') return 'text-secondary-600';
  return 'text-foreground-500';
};

export const trendLabel = (trend: 'up' | 'down' | 'flat'): string => {
  if (trend === 'up') return '上行';
  if (trend === 'down') return '回落';
  return '持平';
};

export const formatDate = (value: string): string => {
  const parts = value.split('-');
  if (parts.length !== 3) return value;
  return `${parts[0]} 年 ${Number(parts[1])} 月 ${Number(parts[2])} 日`;
};

export const statusFilterOptions = [
  { id: 'all', label: '全部' },
  { id: 'live', label: '进行中' },
  { id: 'upcoming', label: '未开始' },
  { id: 'finished', label: '已结束' },
];

export const regionOptions = [
  { id: 'all', label: '全部地区' },
  { id: '国内', label: '国内赛事' },
  { id: '国际', label: '国际赛事' },
];

export const timeRangeOptions = [
  { id: 'all', label: '全部时间' },
  { id: 'today', label: '今天' },
  { id: 'week', label: '近 7 天' },
  { id: 'month', label: '最近一个月' },
];

export const typeOptions = [
  { id: 'all', label: '全部类型' },
  { id: '联赛', label: '联赛' },
  { id: '杯赛', label: '杯赛' },
];

export const sortOptions = [
  { id: 'latest', label: '最新发布' },
  { id: 'earliest', label: '最早发布' },
  { id: 'heat', label: '热度最高' },
];